import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
`;

export const Title = styled.h1`
    color: ${Colors.green[100]};
    font-size: 5rem;
    font-weight: bold;
    margin: 0;
`;

